import { render } from "./financeStatisticsGoods.vue?vue&type=template&id=0c163d23"
import script from "./financeStatisticsGoods.vue?vue&type=script&lang=js"
export * from "./financeStatisticsGoods.vue?vue&type=script&lang=js"

import "./financeStatisticsGoods.vue?vue&type=style&index=0&id=0c163d23&lang=scss"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__